import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant"; // Assuming ROUTES includes a path like BOOKS_PURCHASED_DETAILS_PAGE or similar; adjust as needed

import "./purchasedBookCard.css";

const PurchasedBookCard = (props) => {
  const { book, overall_progress, completed_at } = props;
  const navigate = useNavigate();

  const getGradeDisplay = (gradeLevels) => {
    if (!gradeLevels || gradeLevels.length === 0) return "N/A";
    if (gradeLevels.length === 1) return `Grade ${gradeLevels[0].name}`;
    return `Grades ${gradeLevels[0].name}–${
      gradeLevels[gradeLevels.length - 1].name
    }`;
  };

  const handleClick = () => {
    // Navigate to a reading/details page for the purchased book; adjust ROUTES as per your app's structure
    navigate(`${ROUTES.BOOKS_SELLING_BOOK_DASHBOARD_DETAILS}/${book.slug}`);
  };

  let statusBadge = null;
  let statusClass = "";
  let buttonText = "Start Learning";

  if (completed_at) {
    statusBadge = <span className="badge-completed">Completed</span>;
    statusClass = "badge-completed";
    buttonText = "Review";
  } else if (overall_progress > 0) {
    statusBadge = <span className="badge-in-progress">In Progress</span>;
    statusClass = "badge-in-progress";
    buttonText = "Continue Learning";
  } else {
    statusBadge = <span className="badge-new">New Purchase</span>;
    statusClass = "badge-new";
  }

  return (
    <div
      className="purchased-book-card"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <div className="modern-book-image-wrapper">
        <img
          src={book.cover_image_url}
          alt={book.title}
          className="modern-book-cover"
        />
        <div className="modern-book-badges">
          {book.is_featured && <span className="badge-featured">Featured</span>}
          {statusBadge}
        </div>
        <div className="modern-quick-actions">
          <button className="quick-add-btn" onClick={handleClick}>
            {buttonText}
          </button>
        </div>
      </div>
      <div className="modern-book-info">
        <h3 className="modern-book-title">{book.title}</h3>
        <p className="modern-book-subtitle">{book.subtitle}</p>
        <div className="modern-book-meta">
          <span className="grade-tag">{getGradeDisplay(book.grade_level)}</span>
          <span className="rating">⭐ {book.average_rating || "0.00"}</span>
        </div>
        <div className="modern-progress-section">
          <div className="progress-label">
            {overall_progress > 0
              ? `${overall_progress}% Complete`
              : "Not Started"}
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${overall_progress}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchasedBookCard;
